import type { TooltipCard } from './TooltipCard.types';
import { renderTooltipCards } from './renderTooltipCards';

export function createTooltipContent() {
  let cards: TooltipCard[] = [];

  return {
    setCards(nextCards: TooltipCard[]) {
      cards = nextCards;
    },

    render() {
      return renderTooltipCards(cards);
    },
  };
}
